import { useEffect, useState } from 'react'
import consoleLogger from '../../../../../console-logger'

const useViewPinpoll = () => {
  const [elementId, setElementId] = useState(undefined)
  const [voted, setVoted] = useState(undefined)
  const [consoleLog] = consoleLogger('ViewPinpoll')

  useEffect(() => {
    const viewPinpoll = window.addEventListener('message', (event) => {
      if (!event.origin.endsWith('.pinpoll.com') || !event.data || event.data.event != 'pollView') {
        return
      }
      consoleLog('viewPinpoll', event?.data, 'Pinpoll')
      const sourceVoted = event.data?.isVoted
      const sourceElementId = event.data?.elementId
      const hasChangesVoted = sourceVoted === undefined && sourceVoted !== voted
      const hasChangesElementId = sourceElementId === undefined && sourceElementId !== elementId

      if (hasChangesVoted && hasChangesElementId) {
        return
      }

      setVoted(sourceVoted)
      setElementId(sourceElementId.toString())
    })
    return () => {
      if (viewPinpoll) {
        viewPinpoll.remove()
      }
    }
  }, [])
  return { voted, elementId }
}

export default useViewPinpoll
